<template>
    <b-navbar wrapper-class="container" type="is-white">
        <template slot="brand">
            <b-navbar-item tag="router-link" :to="{ path: '/' }">
                <img
                    src="/images/logo_norm.svg"
                    width="177.7px"
                >
            </b-navbar-item>
        </template>
        <template slot="end">
            <b-navbar-item tag="router-link" :to="{ path: '/' }">
                {{trans[lang].home}}
            </b-navbar-item>
            <b-navbar-item tag="router-link" :to="{ path: '/about' }">
                {{trans[lang].about}}
            </b-navbar-item>
            <b-navbar-item tag="router-link" :to="{ path: '/news' }">
                {{trans[lang].news}}
            </b-navbar-item>
            <b-navbar-item tag="router-link" :to="{ path: '/projects' }">
                {{trans[lang].proj}}
            </b-navbar-item>
            <b-navbar-item  tag="router-link" :to="{ path: '/contacts' }">
                {{trans[lang].cont}}
            </b-navbar-item>

              <b-navbar-item tag="div">
                <div class="buttons">
                    <a @click="showDonate()" class="button is-primary">
                      {{trans[lang].donate}}
                    </a>
                </div>
            </b-navbar-item>

            <b-navbar-item @click="switchLang">
                {{trans[lang].language}}
            </b-navbar-item>
        </template>
    </b-navbar>
</template>
<script>
import { mapState } from "vuex";
export default {
    data() {
        return {
            trans:{
                en: {
                    home: "Home",
                    about: "About",
                    news: "News",
                    proj: "Projects",
                    cont: "Contacts",
                    donate: "Donate",
                    language: "Русский"
                },
                ru: {
                    home: "Главная",
                    about: "О Нас",
                    news: "Новости",
                    proj: "Проекты",
                    cont: "Контакты",
                    donate: "Пожертвования",
                    language: "English"
                },
            }
        };
    },
    methods: {
        switchLang (){
            this.$store.commit("CHANGE_LANG");
        },
        showDonate() {
            this.$router.push({ path: "/donations"});
        }
    },
    computed: {
        ...mapState(["lang"]),
    },
}
</script>
